// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-snackbar-content {
  display: flex;
  align-items: center;
  width: 100%;
  color: white;
  justify-content: space-between;
  font-family: "Lato", sans-serif;
  font-size: 16px;
  height: 40px;
  border-radius: 4px;
}

.error {
  background-color: #d32213;
}

.info {
  background-color: #45b6fe;
}

od-icon {
  color: white;
}

button {
  position: relative;
  border: none;
  background-color: transparent;
  cursor: pointer;
}

.custom-size {
  font-size: 25px;
  margin-left: 12px;
  color: white;
}

mat-icon {
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/_@shared/components/display/toaster/toaster.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,+BAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;AACF","sourcesContent":[".custom-snackbar-content {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  color: white;\n  justify-content: space-between;\n  font-family: 'Lato', sans-serif;\n  font-size: 16px;\n  height: 40px;\n  border-radius: 4px;\n}\n\n.error {\n  background-color: #d32213;\n}\n\n.info {\n  background-color: #45b6fe;\n}\n\nod-icon {\n  color: white;\n}\n\nbutton {\n  position: relative;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n}\n\n.custom-size {\n  font-size: 25px;\n  margin-left: 12px;\n  color: white;\n}\n\nmat-icon {\n  color: white;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
